export const statsFormatter = ({ stats, type, surveyDetails }) => {
  const allSurveysInfo = surveyDetails.allSurveysInfo.reduce((res, survey) => {
    res[survey.name] = {
      status: survey.details.status,
      end_date: survey.details.end_date,
      title: survey.details.messages.en.title
    }
    return res
  }, {})
  const result = Object.keys(stats).reduce((res, statName) => {
    const stat = stats[statName]

    const numberOfResponses = stat.numberOfResponses || 0
    // const numberOfResponses = stat.numberOfResponses // will this work?

    // stat.numberOfResponses = numberOfResponses

    let propsToKeep = {
      messages: { en: { title: statName } }
    }

    if (type === 'questions') {
      const question = surveyDetails.details.categories
        .find((c) => {
          return c.questions.find((q) => q.name === statName)
        })
        ?.questions.find((q) => q.name === statName)
      if (question) {
        propsToKeep.messages = question.details.messages
        if (question.details.precondition) {
          propsToKeep.precondition = question.details.precondition
        }
        if (question.details.theme) {
          propsToKeep.theme = question.details.theme
        }

        if (question.details.messages.en.hasOwnProperty('ranges')) {
          propsToKeep.hasRanges = true
          propsToKeep.rangeKeys = Object.keys(
            question.details.messages.en.ranges
          )
        }
        if (stat.type === 'yesOrNo') {
          if (question.details.yesIsBad) {
            propsToKeep.yesIsBad = question.details.yesIsBad
          }
          if (question.tags && question.tags.includes('harassment')) {
            // force yesIsBad and switch stats around to make it look like all other yesIsBad
            const amount_0 = stat.amount_0 || 0
            const amount_10 = stat.amount_10 || 0
            stat.amount_0 = amount_10
            stat.amount_10 = amount_0
            propsToKeep.yesIsBad = true
            propsToKeep.isHarassmentQuestion = true
          }
          const numberOfPeopleSelectedYes = propsToKeep.yesIsBad
            ? stat.amount_0 || 0
            : stat.amount_10 || 0
          propsToKeep.numberOfPeopleSelectedYes = numberOfPeopleSelectedYes
          propsToKeep.percentageYes = Math.round(
            (numberOfPeopleSelectedYes / numberOfResponses) * 100
          )
        }
        if (question.details.hasOwnProperty('ownResponse')) {
          propsToKeep.ownResponse = question.details.ownResponse
        }
        if (question.details.hasOwnProperty('weight')) {
          propsToKeep.weight = question.details.weight
        }
      }

      const currentSurveyInfo = {
        [surveyDetails.name]: {
          status: surveyDetails.details.status,
          end_date: surveyDetails.details.end_date,
          title: surveyDetails.details.messages.en.title
        }
      }

      const allSurveysInfoWithCurrent = {
        ...currentSurveyInfo,
        ...allSurveysInfo
      }

      if (stat.surveyNames && surveyDetails.details.aggregate) {
        propsToKeep.aggregateInfo = stat.surveyNames.reduce(
          (res, surveyName) => {
            res[surveyName] = allSurveysInfoWithCurrent[surveyName] || {
              status: 'unknown',
              end_date: 'unknown'
            }
            return res
          },
          {}
        )
      }
    } else if (type === 'categories') {
      propsToKeep.messages = surveyDetails.details.categories.find(
        (c) => c.name === statName
      )?.details.messages
      propsToKeep.type = 'category'
    } else if (type === 'tags') {
      const messages = Object.keys(surveyDetails.details.messages).reduce(
        (locales, locale) => {
          locales[locale] = surveyDetails.details.messages[locale]?.tags
            ? surveyDetails.details.messages[locale].tags[statName]
            : surveyDetails.details.messages.en.tags[statName]
          return locales
        },
        {}
      )
      propsToKeep.value = stat.npsData ? stat.npsData.score : stat.value
      propsToKeep.type = 'tag'
      propsToKeep.messages = messages
    }

    if (!propsToKeep) {
    } else {
      res[statName] = { ...stat, ...propsToKeep }
    }

    return res
  }, {})
  return result
}

export const statsComputer = ({ results, surveyDetails }) => {
  const result = Object.keys(results).reduce((res, type) => {
    res[type] = statsFormatter({
      stats: results[type],
      type,
      surveyDetails
    })
    return res
  }, {})
  return result
}
